<div class="container-fluid" *ngIf="!isAsistencia && !isPlanEvaluacion && !isNotas">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <a href="#/panel-admin" class="btn btn-primary">
              Volver
          </a>
        </div>
        <h3 class="page-title">Acción Formativa</h3>
      </div>
    </div>
  </div>
  <!-- end page title -->

  <div class="row" style="overflow-x: scroll;">
    <div class="col-12">
        <div class="card" style="border-color: white;">
          <div class="card-body" style="margin-bottom: 150px;">
            <!-- Invoice Logo-->
            <div class="clearfix">
                <div class="float-start">
                  <div class="row">
                    <label for="ano" class="col-md-4 col-form-label">Año</label>
                    <div class="col-md-8">
                      <select class="form-select" id="ano" name="ano" (change)="onChangeYear($event)">
                        <option *ngFor="let op of years" [value]="op" [selected]="op == selectedYear ? true : false">
                          {{op}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="float-end">
                  <input
                    class="form-control"
                    type="text"
                    id="buscar"
                    placeholder="Buscar acción formativa"
                    [(ngModel)]="searchTerm"
                    (input)="buscarAccionFormativa()"
                  >
                </div>
            </div>
            <hr class="text-dark">
            <div class="row">
              <div class="col-12">
                <table class="table">
                  <thead>
                    <tr class="table-primary">
                      <th scope="col">N°</th>
                      <th>Formación</th>
                      <th>Pre-Impreso</th>
                      <th>Fecha Inicio</th>
                      <th>Facilitador</th>
                      <th>Cupos Disponibles</th>
                      <th>Estatus</th>
                      <th>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let r of filteredResultado; let i = index">
                      <th scope="row">{{i+1}}</th>
                      <td>{{r.nombre_oferta}}</td>
                      <td>{{r.uc_pre_impreso}}</td>
                      <td>{{r.fecha_inicio}}</td>
                      <td>{{r.nombre_facilitador}}</td>
                      <td>{{r.cupo}}</td>
                      <td>{{r.nombre_estatus}}</td>
                      <td>
                        <div class="dropdown">
                          <button class="btn btn-primary" type="button" id="accion" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots-vertical"></i>
                          </button>
                          <ul class="dropdown-menu" aria-labelledby="accion">
                            <li>
                              <a class="dropdown-item puntero" (click)="listar_asistencia(r.id_accion_formativa, r.nombre_oferta, r.uc_pre_impreso, r.fecha_inicio, r.fecha_fin)">
                                Lista de Asistencia
                              </a>
                            </li>
                            <li>
                              <a class="dropdown-item puntero" (click)="plan_evaluacion(r.id_accion_formativa, r.id_oferta_formativa, r.nombre_oferta, r.uc_pre_impreso)">
                                Evaluaciones
                              </a>
                            </li>
                            <li>
                              <a class="dropdown-item puntero" (click)="carga_notas(r.id_accion_formativa, r.nombre_oferta, r.uc_pre_impreso)">
                                Carga de Notas
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>


            </div>



          </div> <!-- end card-body-->
      </div> <!-- end card -->
    </div> <!-- end col-->
  </div>
  <!-- end row -->

</div>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>

<app-listar-asistencia *ngIf="isAsistencia"
[id_accion_formativa]="id_accion_formativa_env"
[anio]="anio_env"
[nombre_oferta]="nombre_uc"
[uc_pre_impreso]="pre_impreso"
[fecha_inicio]="fechInicio"
[fecha_fin]="fechFin"
(vuelve)="volver($event)"></app-listar-asistencia>


<app-plan-evaluacion *ngIf="isPlanEvaluacion"
[id_accion_formativa]="id_accion_formativa_env"
[id_oferta_formativa]="idOferta"
[nombre_oferta]="nombre_uc"
[uc_pre_impreso]="pre_impreso"
(vuelve)="volver($event)"></app-plan-evaluacion>


<app-notas *ngIf="isNotas"
[id_accion_formativa]="id_accion_formativa_env"
[nombre_oferta]="nombre_uc"
[uc_pre_impreso]="pre_impreso"
(vuelve)="volver($event)"></app-notas>
